<template>
  <div class="meeting">
    <div slot="container">
      <div class="meeting-search">
        <el-button type="primary" icon="el-icon-plus" @click="addNews">
          新增会议
        </el-button>
        <!-- <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input> -->
      </div>

      <div class="meeting-table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
          class="table"
        >
          <el-table-column type="index" width="50" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.$index + (current_page - 1) * per_page + 1
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="会议名称"
            prop="name"
            align="center"
          ></el-table-column>
          <el-table-column label="会议封面图" prop="answer" align="center">
            <template slot-scope="scope">
              <img :src="imgUrl + scope.row.coverImage" style="width: 100px" />
            </template>
          </el-table-column>
          <el-table-column
            label="会议时间"
            prop="meetingTime"
            align="center"
          ></el-table-column>
          <el-table-column
            label="会议地点"
            prop="place"
            align="center"
          ></el-table-column>
          <el-table-column align="center" label="操作" width="370">
            <template slot-scope="scope">
              <el-button-group
                ><el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="scope.row.isPublish == 2"
                  class="mini_btn"
                  size="mini"
                  type="warning"
                  @click="handlePush(scope.row, 1)"
                >
                  发布
                </el-button>
                <template v-else>
                  <el-button
                    class="mini_btn"
                    size="mini"
                    type="warning"
                    @click="handlePush(scope.row, 2)"
                  >
                    取消发布
                  </el-button>
                  <el-button
                    class="mini_btn"
                    size="mini"
                    type="success"
                    @click="handlePicture(scope.row)"
                  >
                    上传照片
                  </el-button>
                  <el-button
                    class="mini_btn"
                    size="mini"
                    type="info"
                    @click="handleClear(scope.row)"
                  >
                    清除照片
                  </el-button>
                </template>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="current_page"
        :page-size="per_page"
        layout="total, prev, pager, next"
        :total="total"
        style="text-align:left;margin:20px 0"
      ></el-pagination>
    </div>
    <el-dialog
      :title="Title"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
    >
      <el-form
        :model="formData"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="会议名称" prop="name">
          <el-input
            placeholder="会议名称"
            v-model="formData.name"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          style="text-align: right"
          label="封面图片"
          prop="coverImage"
        >
          <el-upload
            class="avatar-uploader"
            :action="this.uploadURL"
            name="file"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :http-request="(e) => HouImgFile(e, 'coverImage')"
          >
            <img
              v-if="formData.coverImage"
              :src="imgUrl + formData.coverImage"
              class="img_border"
            />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
              :class="{ is_border: !formData.coverImage }"
            ></i>
            <span class="upload_btn" v-if="!formData.coverImage">上传图片</span>
            <span v-else class="upload_btn">更换图片</span>
          </el-upload>
        </el-form-item>
        <el-form-item
          style="text-align: right"
          label="会议座次"
          prop="meetingSeatingImage"
        >
          <el-upload
            class="avatar-uploader"
            :action="this.uploadURL"
            name="file"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :http-request="(e) => HouImgFile(e, 'meetingSeatingImage')"
          >
            <img
              v-if="formData.meetingSeatingImage"
              :src="imgUrl + formData.meetingSeatingImage"
              class="img_border"
            />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
              :class="{ is_border: !formData.meetingSeatingImage }"
            ></i>
            <span class="upload_btn" v-if="!formData.coverImage">上传图片</span>
            <span v-else class="upload_btn">更换图片</span>
          </el-upload>
        </el-form-item>
        <el-form-item label="会议时间" prop="meetingTime">
          <el-date-picker
            v-model="formData.meetingTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择会议时间"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="会议地点:" prop="place">
          <el-input
            placeholder="会议地点"
            v-model="formData.place"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="会议指南:" prop="guidebook">
          <el-upload
            :action="this.uploadURL"
            style="text-align: left;"
            :before-upload="beforeFiledUpload"
            :on-remove="handleRemove"
            :limit="1"
            :file-list="fileList"
            :on-success="handleSuccess"
            list-type="fileList"
          >
            <el-button size="small" type="primary"
              >上传附件（仅支持Word/PDF格式）</el-button
            >
          </el-upload>
        </el-form-item>
        <el-form-item label="需求汇编:" prop="compilationResultsFile">
          <el-upload
            :action="this.uploadURL"
            style="text-align: left;"
            :before-upload="beforeFiledUpload"
            :on-remove="handleRemove1"
            :limit="1"
            :file-list="fileList1"
            :on-success="handleSuccess1"
            list-type="fileList"
          >
            <el-button size="small" type="primary"
              >上传附件（仅支持Word/PDF格式）</el-button
            >
          </el-upload>
        </el-form-item>
        <el-form-item label="成果汇编:" prop="requirementsCompilationFile">
          <el-upload
            :action="this.uploadURL"
            style="text-align: left;"
            :before-upload="beforeFiledUpload"
            :on-remove="handleRemove2"
            :limit="1"
            :file-list="fileList2"
            :on-success="handleSuccess2"
            list-type="fileList"
          >
            <el-button size="small" type="primary"
              >上传附件（仅支持Word/PDF格式）</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提交</el-button
        >
      </template>
    </el-dialog>
    <el-dialog
      title="上传图片"
      :visible.sync="uploadVisible"
      :modal-append-to-body="false"
    >
      <div class="upload_img">
        <el-upload
          :action="this.uploadURL"
          :before-upload="beforeAvatarUpload"
          :on-remove="handlePictureRemove"
          :on-success="handlePictureSuccess"
          multiple
          list-type="picture"
          style="text-align: left;"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过10MB
          </div>
        </el-upload>
      </div>

      <template slot="footer">
        <el-button @click="uploadVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPicture">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      current_page: 1,
      per_page: 10,
      total: 1,
      Title: "新增会议",
      dialogVisible: false,
      formData: {
        name: "",
        coverImage: "",
        meetingSeatingImage: "",
        meetingTime: "",
        place: "",
        guidebook: "",
        isPublish: 1,
        compilationResultsFile: "",
        requirementsCompilationFile: "",
      },
      rules: {
        name: [{ required: true, message: "请输入会议名称", trigger: "blur" }],
        coverImage: [
          { required: true, message: "请上传会议封面", trigger: "blur" },
        ],
      },
      fileList: [],
      fileList1: [],
      fileList2: [],
      uploadVisible: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handlePicture(item) {
      this.formData = item;
      this.fileList = [];
      this.uploadVisible = true;
    },
    addNews() {
      const item = this.tableData.find((item) => item.isPublish == 1);
      if (item) {
        this.$message.error("先取消发布其他会议后，再发布该会议");
        return;
      }
      this.Title = "新增会议";
      this.formData = {
        name: "",
        coverImage: "",
        meetingTime: "",
        place: "",
        guidebook: "",
        isPublish: 1,
        meetingSeatingImage: "",
      };
      this.dialogVisible = true;
    },
    //翻页
    handleCurrentChange(val) {
      this.current_page = val;
      this.getData();
      //   this.getData('Knowledge?type=1&page=' + val);
    },
    getData() {
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-sign-in/page`, {
          page: this.current_page,
          pageSize: this.per_page,
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
    },
    handleEdit(item) {
      this.Title = "编辑会议";
      this.formData = item;
      if (item.guidebook) {
        this.fileList = [
          {
            url: item.guidebook,
            name: item.guidebook.split("/").pop(),
          },
        ];
      }
      if (item.compilationResultsFile) {
        this.fileList1 = [
          {
            url: item.compilationResultsFile,
            name: item.compilationResultsFile.split("/").pop(),
          },
        ];
      }
      if (item.requirementsCompilationFile) {
        this.fileList2 = [
          {
            url: item.requirementsCompilationFile,
            name: item.requirementsCompilationFile.split("/").pop(),
          },
        ];
      }
      this.dialogVisible = true;
    },
    handlePush(item, status) {
      this.http
        .post(
          `${urlConfig.devUrl}apij2/admin-api/trade/meeting-sign-in/updatePublish`,
          {
            ...item,
            isPublish: status,
          }
        )
        .then((res) => {
          const string = status == 1 ? "发布成功" : "取消发布成功";
          this.$message({
            type: "success",
            message: string,
          });
          this.getData();
        });
    },
    // 清除直播照片
    handleClear(item) {
      this.$confirm("确定要清除所有直播图片？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
      }).then(() => {
        this.http
          .delete(
            `${urlConfig.devUrl}apij2/admin-api/trade/meeting-sign-in/deleteImage?id=${item.id}`
          )
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "清除成功",
              });
            }
          });
      });
    },
    handleDelete(item) {
      const str =
        item.isPublish == 1 ? "确定要取消发布并删除会议吗" : "确定要删除会议吗";
      this.$confirm(str, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
      }).then(() => {
        this.http
          .delete(
            `${urlConfig.devUrl}apij2/admin-api/trade/meeting-sign-in/delete?id=${item.id}`
          )
          .then((res) => {
            if (res.code == 0) {
              this.current_page = 1;
              this.getData();
              this.$message({
                type: "success",
                message: "删除成功",
              });
            } else {
              this.$message({
                message: "失败！",
                type: "error",
              });
            }
          });
      });
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    HouImgFile(e, name) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, name);
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.formData[Name] = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    beforeFiledUpload(file) {
      let type = false;
      if (
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!type) {
        this.$message.error("上传图片只能是 pdf/doc/docx 形式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 50MB!");
      }
      return type && isLt2M;
    },
    handleRemove() {
      this.formData.guidebook = "";
    },
    handleSuccess(res) {
      this.formData.guidebook = res.data.store_result;
    },

    handleRemove1() {
      this.formData.compilationResultsFile = "";
    },
    handleSuccess1(res) {
      this.formData.compilationResultsFile = res.data.store_result;
    },

    handleRemove2() {
      this.formData.requirementsCompilationFile = "";
    },
    handleSuccess2(res) {
      this.formData.requirementsCompilationFile = res.data.store_result;
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const url = this.formData.id ? "update" : "create";
          this.http
            .post(
              `${urlConfig.devUrl}apij2/admin-api/trade/meeting-sign-in/${url}`,
              this.formData
            )
            .then((res) => {
              const string = this.formData.id ? "更新成功" : "发布成功";
              this.$message({
                type: "success",
                message: string,
              });
              this.dialogVisible = false;
              this.current_page = 1;
              this.getData();
            });
        }
      });
    },
    handlePictureRemove(file) {
      this.fileList = this.fileList.filter(
        (item) => item.url !== file.response.data.store_result
      );
    },
    handlePictureSuccess(res) {
      if (res.code == 0) {
        this.fileList.push({
          url: res.data.store_result,
        });
      }
    },
    submitPicture() {
      if (this.fileList.length < 1) {
        this.$message.info("请上传图片");
        return;
      }
      const list = this.fileList.map((item) => item.url);
      this.http
        .post(
          `${urlConfig.devUrl}apij2/admin-api/trade/meeting-sign-in/uploadImage`,
          {
            id: this.formData.id,
            multipleImage: list.join(","),
          }
        )
        .then((res) => {
          this.$message({
            type: "success",
            message: "上传成功",
          });
          this.uploadVisible = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@include component(meeting) {
  width: 100%;
  height: 100%;
  .meeting-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }
  .meeting-table {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #eef1f6;
  }
  .avatar-uploader {
    text-align: center;
    width: 243px;
    img {
      max-width: 100%;
    }
  }
  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }

  .upload_img {
    padding: 20px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
  }
}
</style>
